/* eslint-disable */
//Note: Just changed the extension to support <icon component used in constants
//TODO: Refactor this file or enable tree-shaking
import { Icon } from 'ui'
import { AscentLogo } from '~/components/AscentLogo'
import { AuxiloLogo } from '~/components/AuxiloLogo'

import { ApplicationType } from './dashboard'

export const STEP_NUMBER = {
  email: 2,
  phone: 3,
  address: 4,
  mailingAddress: 5,
  immigrationStatus: 6,
  visa: 7,
  disclosure: 8,
}

export const SEMESTERS = [
  { name: '1 Semester', id: '1 Semester' },
  { name: '2 Semesters', id: '2 Semesters' },
  { name: '3 Semesters', id: '3 Semesters' },
  { name: '4 Semesters', id: '4 Semesters' },
  { name: '5 Semesters', id: '5 Semesters' },
]

export const SEMESTERS_RB = ['1 Semester', '2 Semesters', '3 Semesters', '4 Semesters']

export const YES_NO_DDN = [
  { id: 'Yes', name: 'Yes' },
  { id: 'No', name: 'No' },
]
export const SCHOOL_GOVT_OTHER = [
  { id: 'School', name: 'School' },
  { id: 'Government', name: 'Government' },
  { id: 'Other', name: 'Other' },
]
export const SALUTATION = [
  { id: 'Mr.', name: 'Mr.' },
  { id: 'Ms./Mrs.', name: 'Ms./Mrs.' },
  { id: 'Prefer not to say', name: 'Other' },
]
export const SALUTATION_PROFILE = ['Mr.', 'Ms./Mrs.']

export const PERSONAL_TEXTMAP_FIRST_NAME: Record<string, string> = {
  [ApplicationType.US_GRAD]: "First name (as per your US Driver's License)",
  [ApplicationType.IN_SCHOOL]: 'First Name (as per your passport)',
}

export const PERSONAL_TEXTMAP_LAST_NAME: Record<string, string> = {
  [ApplicationType.US_GRAD]: "Last name (as per your US Driver's License)",
  [ApplicationType.IN_SCHOOL]: 'Last Name (as per your passport)',
}

export const PERSONAL_TEXTMAP_INDEX_TIP: Record<string, string> = {
  [ApplicationType.US_GRAD]:
    "If you have multiple first or last names, enter them as they appear on your passport, US driver's license, or other legal documents. If you have a middle name, add it to the first name field.",
  [ApplicationType.IN_SCHOOL]:
    'If you have multiple first or last names, enter them as they appear on your passport or other legal documents. If you have a middle name, add it to the first name field.',
}

export const PERSONAL_TEXTMAP_INDEX_TIP_GENERIC =
  'If you have multiple first or last names, enter them as they appear on your passport or other legal documents. If you have a middle name, add it to the first name field.'

export const PERSONAL_TEXTMAP_CITIZENSHIP_C: Record<string, string> = {
  [ApplicationType.US_GRAD]: 'Your citizenship country',
  [ApplicationType.IN_SCHOOL]: 'Your Passport Country',
}

export const PERSONAL_TEXTMAP_ADDRESS_TIP: Record<string, string> = {
  [ApplicationType.US_GRAD]: ' ',
  [ApplicationType.IN_SCHOOL]: ' ',
}

export const ADDRESS_TEXTMAP_TITLE_CITIZENSHIP: Record<string, string> = {
  [ApplicationType.US_GRAD]: 'citizenship country',
  [ApplicationType.IN_SCHOOL]: 'passport country',
}

export const ADDRESS_TEXTMAP_TITLE_PERMANENT_QUESTION: Record<string, string> = {
  [ApplicationType.US_GRAD]: 'mailing address in the United States?',
  [ApplicationType.IN_SCHOOL]: 'permanent address?',
}

export const PERSONAL_TEXTMAP_ADDRESS_TIP_GENRIC =
  ' Your permanent address is an address that does not change on a regular basis, usually from your home country where you or your family members permanently reside; it might not be the address you currently live at. We use this to confirm your citizenship in your home country.'

export const EMPLOYMENT_TYPES = [
  { id: 'Full-time', name: 'Full time' },
  { id: 'Part-time', name: 'Part time' },
]

export const REFERENCE_RELATION = [
  'Friend',
  'Parent',
  'Manager or Employer (Past / Current)',
  'Academic Advisor (Past / Current)',
  'Other',
]

export const VISA_TYPES_DROPDOWN = [
  'F-1',
  'H-1B',
  'J-1',
  'H-4',
  'A-1',
  'A-2',
  'C-3',
  'C-4',
  'DACA',
  'E',
  'F-2',
  'G',
  'H-1B1',
  'H-1B2',
  'H-1B3',
  'H-2B',
  'H-3',
  'J-2',
  'K-1',
  'K-2',
  'K-3',
  'K-4',
  'L-1',
  'L-1A',
  'L-1B',
  'L-2',
  'NATO',
  'O-1',
  'O-2',
  'O-3',
  'R-1',
  'R-2',
  'Refugee',
  'T-1',
  'T-2',
  'T-3',
  'T-4',
  'T-5',
  'T-6',
  'TD',
  'TN',
  'TPS',
  'U-1',
  'U-2',
  'U-3',
  'U-4',
  'U-5',
  'V-1',
  'OTHER',
]

export const VISA_TYPES_CANADA_DROPDOWN = [
  'Yes, I have a Study Permit',
  'Yes, I have a Work Permit',
  "No, I don't have one yet",
]

export const VISA_TYPES = [
  { id: 'F-1', name: 'F-1' },
  { id: 'H-1B', name: 'H-1B' },
  { id: 'J-1', name: 'J-1' },
  { id: 'H-4', name: 'H-4' },
  { id: 'H-1B1', name: 'H-1B1' },
  { id: 'A', name: 'A' },
  { id: 'E-1', name: 'E-1' },
  { id: 'E-2', name: 'E-2' },
  { id: 'E-3', name: 'E-3' },
  { id: 'G-1', name: 'G-1' },
  { id: 'G-2', name: 'G-2' },
  { id: 'G-3', name: 'G-3' },
  { id: 'C-4', name: 'C-4' },
  { id: 'K-1', name: 'K-1' },
  { id: 'L-1', name: 'L-1' },
  { id: 'L-2', name: 'L-2' },
  { id: 'NATO', name: 'NATO' },
  { id: 'O-1', name: 'O-1' },
  { id: 'Class M', name: 'Class M' },
  { id: 'Temporary visa', name: 'Temporary visa' },
  { id: 'Refugee', name: 'Refugee' },
]
export const VISA_TYPES_CANADA = [
  { id: 'Yes, I have a Study Permit', name: 'Yes, I have a Study Permit' },
  { id: 'Yes, I have a Work Permit', name: 'Yes, I have a Work Permit' },
  { id: "No, I don't have one yet", name: "No, I don't have one yet" },
]

export const PERSONAL_SAVINGS = [
  { id: 'Savings', name: 'Savings' },
  { id: 'Investments', name: 'Investments' },
  { id: 'Wages/earnings', name: 'Wages/earnings' },
]

export const SPONSOR_FUNDING = [
  { id: 'Employer', name: 'Employer' },
  { id: 'Business', name: 'Business' },
  { id: 'Other', name: 'Other' },
]

export const IMMIGRATION_TYPE = [
  { id: 'Non-citizen', name: 'Non-citizen' },
  { id: 'DACA', name: 'DACA' },
  { id: 'Permanent resident', name: 'Permanent resident' },
  { id: 'Asylum seeker/refugee', name: 'Asylum seeker/refugee' },
  { id: 'Citizen', name: 'Citizen' },
]

export const IMMIGRATION_TYPE_CANADA = [
  { id: 'Non-citizen', name: 'Non-citizen' },
  { id: 'Permanent resident', name: 'Permanent resident' },
]

export const SOURCE_OF_HEARING_NEW = [
  'Online search',
  'Admission Partner',
  'Referral from a friend',
  'University staff or website',
  'Promotion',
  'OnlineAd',
  'Quora',
  'Facebook',
  'LinkedIn',
  'Youtube',
  'Social media',
  'Messenger(Whatsapp, etc.)',
  'News / Press article',
  'Scholarship program',
  'Information session or conference',
  'Twitter',
  'Other',
]

export const PARTNER_NAMES = [
  { id: '5C Edtech', name: '5C Edtech' },
  { id: '1st Avenue', name: '1st Avenue' },
  { id: '3W Funding', name: '3W Funding' },
  { id: '007 Agent', name: '007 Agent' },
  { id: 'Admit.Me', name: 'Admit.Me' },
  { id: 'Admitkard', name: 'Admitkard' },
  { id: 'Advancity', name: 'Advancity' },
  { id: 'AECC Indonesia', name: 'AECC Indonesia' },
  { id: 'AECC Nigeria', name: 'AECC Nigeria' },
  { id: 'AECC Philippines', name: 'AECC Philippines' },
  { id: 'AECC Vietnam', name: 'AECC Vietnam' },
  { id: 'AES Estudios', name: 'AES Estudios' },
  { id: 'AIESEC', name: 'AIESEC' },
  { id: 'Almond Tutoring', name: 'Almond Tutoring' },
  { id: 'Alok Bansal', name: 'Alok Bansal' },
  { id: 'Ambitio', name: 'Ambitio' },
  { id: 'American Education Pathways', name: 'American Education Pathways' },
  { id: 'ANT Study Abroad', name: 'ANT Study Abroad' },
  { id: 'Apice', name: 'Apice' },
  { id: 'ApplicantLab', name: 'ApplicantLab' },
  { id: 'Applyboard', name: 'Applyboard' },
  { id: 'Applyboard Africa', name: 'Applyboard Africa' },
  { id: 'Arona International', name: 'Arona International' },
  { id: 'Ascent', name: 'Ascent' },
  { id: 'AskArbol', name: 'AskArbol' },
  { id: 'Astrum Great Indian Scholars (AGIS)', name: 'Astrum Great Indian Scholars (AGIS)' },
  { id: 'AUCA', name: 'AUCA' },
  { id: 'Avanti Prep', name: 'Avanti Prep' },
  { id: 'Baidu', name: 'Baidu' },
  { id: 'Black Orchid', name: 'Black Orchid' },
  { id: 'BLP', name: 'BLP' },
  { id: 'blue-ivy', name: 'blue-ivy' },
  { id: 'BorderPass', name: 'BorderPass' },
  { id: 'Careerline', name: 'Careerline' },
  { id: 'Catalyst Gem', name: 'Catalyst Gem' },
  { id: 'CBIE', name: 'CBIE' },
  { id: 'ChaseDream', name: 'ChaseDream' },
  { id: 'College Finance', name: 'College Finance' },
  { id: 'Nitro', name: 'Nitro' },
  { id: 'Colfuturo', name: 'Colfuturo' },
  { id: 'CollegeDaily', name: 'CollegeDaily' },
  { id: 'Collegedunia', name: 'Collegedunia' },
  { id: 'Collegepond', name: 'Collegepond' },
  { id: 'Council For American Education', name: 'Council For American Education' },
  { id: 'Credenc', name: 'Credenc' },
  { id: 'Credit Clan', name: 'Credit Clan' },
  { id: 'CSDN', name: 'CSDN' },
  { id: 'CTPL', name: 'CTPL' },
  { id: 'CUAC', name: 'CUAC' },
  { id: 'Daquiprafora', name: 'Daquiprafora' },
  { id: 'Dreambridge', name: 'Dreambridge' },
  { id: 'EdAssist', name: 'EdAssist' },
  { id: 'Edfin Microfinance Bank', name: 'Edfin Microfinance Bank' },
  { id: 'Edgrad', name: 'Edgrad' },
  { id: 'Education Pathways to Canada (EPTC)', name: 'Education Pathways to Canada (EPTC)' },
  { id: 'Education USA', name: 'Education USA' },
  { id: 'Educatly', name: 'Educatly' },
  { id: 'Eduloans', name: 'Eduloans' },
  { id: 'Edumate Global', name: 'Edumate Global' },
  { id: 'EduPass', name: 'EduPass' },
  { id: 'Edvisory', name: 'Edvisory' },
  { id: 'Edvoy', name: 'Edvoy' },
  { id: 'Edwise Foundation-Nepal', name: 'Edwise Foundation-Nepal' },
  { id: 'EIS Board', name: 'EIS Board' },
  { id: 'Elyt', name: 'Elyt' },
  { id: 'Enrizon', name: 'Enrizon' },
  { id: 'Estudiantes Embajadores', name: 'Estudiantes Embajadores' },
  { id: 'ETS', name: 'ETS' },
  { id: 'Flutterwave', name: 'Flutterwave' },
  { id: 'Foreign Admits', name: 'Foreign Admits' },
  { id: 'Fullbright-Mexico', name: 'Fullbright-Mexico' },
  { id: 'Fundacion Beca', name: 'Fundacion Beca' },
  { id: 'fund-estudar', name: 'fund-estudar' },
  { id: 'Future Counselors', name: 'Future Counselors' },
  { id: 'Futurense', name: 'Futurense' },
  { id: 'Galvanize Test Prep', name: 'Galvanize Test Prep' },
  { id: 'Global Education Systems', name: 'Global Education Systems' },
  { id: 'Global Study Partners', name: 'Global Study Partners' },
  { id: 'Globus Education Systems', name: 'Globus Education Systems' },
  { id: 'Globus Edus Systems', name: 'Globus Edus Systems' },
  { id: 'Go Easy Immigration', name: 'Go Easy Immigration' },
  { id: 'Go Study', name: 'Go Study' },
  { id: 'GradLife Canada', name: 'GradLife Canada' },
  { id: 'GradRight', name: 'GradRight' },
  { id: 'GTER', name: 'GTER' },
  { id: 'GyanDhan', name: 'GyanDhan' },
  { id: 'Happy Schools', name: 'Happy Schools' },
  {
    id: 'Holistic Business Education Centres - Academic Research Institute',
    name: 'Holistic Business Education Centres - Academic Research Institute',
  },
  { id: 'HS Consultants', name: 'HS Consultants' },
  { id: 'HugsIntl', name: 'HugsIntl' },
  { id: 'i20 Fever', name: 'i20 Fever' },
  { id: 'IDream Career', name: 'IDream Career' },
  { id: 'Imperial Overseas', name: 'Imperial Overseas' },
  { id: 'IMS', name: 'IMS' },
  { id: 'Immiway International', name: 'Immiway International' },
  { id: 'Interglobe', name: 'Interglobe' },
  { id: 'International Scholars Program (ISP)', name: 'International Scholars Program (ISP)' },
  { id: 'iSchoolConnect', name: 'iSchoolConnect' },
  { id: 'Ivy Overseas', name: 'Ivy Overseas' },
  { id: 'Jamboree', name: 'Jamboree' },
  { id: 'Juno', name: 'Juno' },
  { id: 'Kanan International', name: 'Kanan International' },
  { id: 'Kareer Krafters', name: 'Kareer Krafters' },
  { id: 'KC Overseas', name: 'KC Overseas' },
  { id: 'LAE', name: 'LAE' },
  { id: 'La Republica', name: 'La Republica' },
  { id: 'Learners Cortex', name: 'Learners Cortex' },
  { id: 'Lendedu', name: 'Lendedu' },
  { id: 'Lending Tree', name: 'Lending Tree' },
  { id: 'Leverage Edu', name: 'Leverage Edu' },
  { id: 'Libereka', name: 'Libereka' },
  { id: 'Loanhero', name: 'Loanhero' },
  { id: 'Logismos Education', name: 'Logismos Education' },
  { id: 'LXKW', name: 'LXKW' },
  { id: 'manya', name: 'manya' },
  { id: 'Maple Corp', name: 'Maple Corp' },
  { id: 'Matchup Global', name: 'Matchup Global' },
  { id: 'MetaApply', name: 'MetaApply' },
  { id: 'Mim-Essay', name: 'Mim-Essay' },
  { id: 'Mind the Gap', name: 'Mind the Gap' },
  { id: 'MSM Unify', name: 'MSM Unify' },
  { id: 'MyAdmissions', name: 'MyAdmissions' },
  { id: 'Nerdwallet', name: 'Nerdwallet' },
  { id: 'Nomad Credit', name: 'Nomad Credit' },
  { id: 'nomad-global', name: 'nomad-global' },
  { id: 'Nova Credit', name: 'Nova Credit' },
  { id: 'NIEC', name: 'NIEC' },
  { id: 'OAA Study', name: 'OAA Study' },
  { id: 'P2vest', name: 'P2vest' },
  { id: 'PalmDrive', name: 'PalmDrive' },
  { id: 'Panacea Financial', name: 'Panacea Financial' },
  { id: 'Pave', name: 'Pave' },
  { id: 'Pay4Me', name: 'Pay4Me' },
  { id: 'Physicswallah', name: 'Physicswallah' },
  { id: 'Peaceful Loans', name: 'Peaceful Loans' },
  { id: 'Preparation for Life', name: 'Preparation for Life' },
  { id: 'Princeton Review', name: 'Princeton Review' },
  { id: 'ProConnect Pay', name: 'ProConnect Pay' },
  { id: 'Proventus Education', name: 'Proventus Education' },
  { id: 'ProuEducation', name: 'ProuEducation' },
  { id: 'Quick Eduloan', name: 'Quick Eduloan' },
  { id: 'Quizplus', name: 'Quizplus' },
  { id: 'Sallie Mae', name: 'Sallie Mae' },
  { id: 'School Finder', name: 'School Finder' },
  { id: 'Scoreleap', name: 'Scoreleap' },
  { id: 'Seed Global Africa', name: 'Seed Global Africa' },
  { id: 'Shiksha', name: 'Shiksha' },
  { id: 'Shorelight', name: 'Shorelight' },
  { id: 'SIEC Education', name: 'SIEC Education' },
  { id: 'SLG Africa', name: 'SLG Africa' },
  { id: 'SOS Labour', name: 'SOS Labour' },
  { id: 'SparrowFi', name: 'SparrowFi' },
  { id: 'Stilt', name: 'Stilt' },
  { id: 'StudentFi', name: 'StudentFi' },
  { id: 'Study Metro', name: 'Study Metro' },
  { id: 'Study Portals', name: 'Study Portals' },
  { id: 'StudyUSA', name: 'StudyUSA' },
  { id: 'StudyWeg', name: 'StudyWeg' },
  { id: 'Success Factor', name: 'Success Factor' },
  { id: 'Sunlight', name: 'Sunlight' },
  { id: 'Switch My Loan', name: 'Switch My Loan' },
  { id: 'Texas Review', name: 'Texas Review' },
  { id: 'Times Higher Education', name: 'Times Higher Education' },
  { id: 'TitanR Consulting', name: 'TitanR Consulting' },
  { id: 'Trav4College', name: 'Trav4College' },
  { id: 'TravelMate', name: 'TravelMate' },
  { id: 'Trotamundos', name: 'Trotamundos' },
  { id: 'Trumphan', name: 'Trumphan' },
  { id: 'Tuapply', name: 'Tuapply' },
  {
    id: 'UK Student World (Student World UK Ltd)',
    name: 'UK Student World (Student World UK Ltd)',
  },
  { id: 'Uniaway', name: 'Uniaway' },
  { id: 'Unicreds', name: 'Unicreds' },
  { id: 'Uniexplore', name: 'Uniexplore' },
  { id: 'Uniserv Education', name: 'Uniserv Education' },
  { id: 'Upgrad', name: 'Upgrad' },
  { id: 'US News & World Report', name: 'US News & World Report' },
  { id: 'UTEC', name: 'UTEC' },
  { id: 'Valmiki Group', name: 'Valmiki Group' },
  { id: 'Verbatoria', name: 'Verbatoria' },
  { id: 'Bmi Global/Viva Mundo', name: 'Bmi Global/Viva Mundo' },
  { id: 'WECare Capital', name: 'WECare Capital' },
  { id: 'WeChat', name: 'WeChat' },
  { id: 'Westend Educorp', name: 'Westend Educorp' },
  { id: 'Y-Axis', name: 'Y-Axis' },
  { id: 'Yes You Can', name: 'Yes You Can' },
  { id: 'Yocket', name: 'Yocket' },
  { id: 'YouthTalent', name: 'YouthTalent' },
  { id: 'Zhihu', name: 'Zhihu' },
  { id: 'ZhishiQ', name: 'ZhishiQ' },
  { id: 'Zinc Money', name: 'Zinc Money' },
  { id: 'Zolve', name: 'Zolve' },
  { id: 'Zoropay', name: 'Zoropay' },
  { id: 'ABSA', name: 'ABSA' },
  { id: 'Fund Abroad', name: 'Fund Abroad' },
  { id: 'Global Degrees', name: 'Global Degrees' },
  { id: 'We Fund Your Future', name: 'We Fund Your Future' },
  { id: 'Grads Gateway', name: 'Grads Gateway' },
  { id: 'IAEC Consultants', name: 'IAEC Consultants' },
  { id: 'Santa Monica', name: 'Santa Monica' },
  { id: 'Impact Financing', name: 'Impact Financing' },
  { id: 'Globally Recruit', name: 'Globally Recruit' },
  { id: 'Gee Bee Education', name: 'Gee Bee Education' },
  { id: 'Miles Education', name: 'Miles Education' },
  { id: 'Acumen', name: 'Acumen' },
  { id: 'Global Opportuinities', name: 'Global Opportuinities' },
  { id: 'Klassfin', name: 'Klassfin' },
  { id: 'Study Circle', name: 'Study Circle' },
  { id: 'Lorien Finance', name: 'Lorien Finance' },
  { id: 'Ubergrad', name: 'Ubergrad' },
  {
    id: 'Fil-Global Lending Services Corporation',
    name: 'Fil-Global Lending Services Corporation',
  },
  { id: 'Edwise Consultancy-Bangladesh', name: 'Edwise Consultancy-Bangladesh' },
  { id: 'Mission to Top U', name: 'Mission to Top U' },
  { id: 'EdNet', name: 'EdNet' },
  { id: 'Other MPOWER Partner', name: 'Other MPOWER Partner' },
  { id: 'Grace International-Nepal', name: 'Grace International-Nepal' },
  { id: 'Exxeella', name: 'Exxeella' },
  { id: 'Interface Education Centre-Nepal', name: 'Interface Education Centre-Nepal' },
  { id: 'Vsource-Fintech', name: 'Vsource-Fintech' },
  { id: 'Edubanc', name: 'Edubanc' },
  { id: 'College Finder', name: 'College Finder' },
  { id: 'Enbee Education Center (EEC Global)', name: 'Enbee Education Center (EEC Global)' },
  { id: 'Nbyula', name: 'Nbyula' },
  { id: 'Anchornetwork', name: 'Anchornetwork' },
  { id: 'Maven Consulting Services', name: 'Maven Consulting Services' },
  { id: 'EduFund', name: 'EduFund' },
  { id: 'EdMIUM', name: 'EdMIUM' },
  { id: 'Study Befikar', name: 'Study Befikar' },
  { id: 'IMFS', name: 'IMFS' },
  { id: 'AECC India', name: 'AECC India' },
  { id: 'Global Tree', name: 'Global Tree' },
  { id: 'Abroad Campus', name: 'Abroad Campus' },
  { id: 'One Window Overseas Education', name: 'One Window Overseas Education' },
  { id: 'Adansi Travels', name: 'Adansi Travels' },
  { id: 'Ecobank', name: 'Ecobank' },
  { id: 'Union Bank', name: 'Union Bank' },
  { id: 'Rupegeduconsult', name: 'Rupegeduconsult' },
  { id: 'ESB Pathways', name: 'ESB Pathways' },
  { id: 'Come Study International', name: 'Come Study International' },
  { id: 'Astolinks', name: 'Astolinks' },
  { id: 'Career Leap Africa', name: 'Career Leap Africa' },
  { id: 'WinStar Education', name: 'WinStar Education' },
  { id: 'Career Paths', name: 'Career Paths' },
  { id: 'Wisdom Education', name: 'Wisdom Education' },
  { id: 'Student Connection', name: 'Student Connection' },
  { id: 'MACES', name: 'MACES' },
  { id: "Mentors' Study Abroad", name: "Mentors' Study Abroad" },
  { id: 'Eurasia', name: 'Eurasia' },
  { id: 'Faith Overseas', name: 'Faith Overseas' },
  { id: 'Kompass Education', name: 'Kompass Education' },
  { id: 'MSM Unify Africa', name: 'MSM Unify Africa' },
  { id: 'America Education Pathways', name: 'America Education Pathways' },
  { id: 'Colfuturo', name: 'Colfuturo' },
  { id: 'GSG Education', name: 'GSG Education' },
  { id: 'Moove Vistos', name: 'Moove Vistos' },
  { id: 'Grade Up', name: 'Grade Up' },
  { id: 'LAE', name: 'LAE' },
  { id: 'Education USA Latam', name: 'Education USA Latam' },
  { id: 'Admit Canada', name: 'Admit Canada' },
  { id: 'Bridge Group', name: 'Bridge Group' },
  { id: 'Education Abroad Latin America', name: 'Education Abroad Latin America' },
  { id: 'Agentes Universitarios', name: 'Agentes Universitarios' },
  { id: 'Universal Education Latam', name: 'Universal Education Latam' },
  { id: 'Seeking English', name: 'Seeking English' },
  { id: 'Global Admission Center', name: 'Global Admission Center' },
  { id: 'Overseas Frontiers', name: 'Overseas Frontiers' },
  { id: 'INTO University Partnerships', name: 'INTO University Partnerships' },
]

export const PARENT_RELATIVE_FRIEND = [
  { id: 'Parent', name: 'Parent' },
  { id: 'Relative', name: 'Relative' },
  { id: 'Friend', name: 'Friend' },
]
export const PROGRAM_TYPE = [
  {
    id: 'on_campus',
    name: 'On campus',
    icon: () => <Icon name="college" />,
  },
  {
    id: 'online',
    name: 'Online',
    icon: () => <Icon name="online" />,
  },
  {
    id: 'blended',
    name: 'Hybrid',
    icon: () => <Icon name="hybrid" />,
  },
]

export const ACCOUNT_TYPE = [
  { id: 'Savings', name: 'Savings' },
  { id: 'Investments', name: 'Investments' },
  { id: 'Wages/earnings', name: 'Wages/earnings' },
]

export const GRADES = [
  {
    id: '1st year undergraduate',
    name: '1st year undergraduate',
    icon: '',
    type: '',
  },
  {
    id: '2nd year undergraduate',
    name: '2nd year undergraduate',
    icon: '',
    type: '',
  },
  {
    id: '3rd year undergraduate',
    name: '3rd year undergraduate',
    icon: '',
    type: '',
  },
  {
    id: '4th year undergraduate',
    name: '4th year undergraduate',
    icon: '',
    type: '',
  },
  {
    id: '5th year undergraduate',
    name: '5th year undergraduate',
    icon: '',
    type: '',
  },
  {
    id: '1st year graduate',
    name: '1st year graduate',
    icon: '',
    type: 'masters',
  },
  {
    id: '2nd year graduate',
    name: '2nd year graduate',
    icon: '',
    type: 'masters',
  },
  {
    id: '3rd year graduate',
    name: '3rd year graduate',
    icon: '',
    type: 'masters',
  },
  {
    id: 'Beyond 3rd year graduate',
    name: 'Beyond 3rd year graduate',
    icon: '',
    type: 'masters',
  },
]
export const MONTHS_NAME = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
export const DEBT_LOAN = [
  { id: 'Credit Card', name: 'Credit Card' },
  { id: 'Mortgage', name: 'Mortgage' },
  { id: 'Car loan', name: 'Car loan' },
  { id: 'Other student loans', name: 'Other student loans' },
  { id: 'Other Debt', name: 'Other Debt' },
]

export const DEGREES = [
  { id: 'Masters', name: "Master's", eligible: true },
  { id: 'MBA', name: 'MBA', eligible: true },
  { id: 'PhD', name: 'PhD', eligible: true },
  { id: 'JD', name: 'JD', eligible: true },
  { id: "Bachelor's", name: "Bachelor's", eligible: true },
  { id: 'MD', name: 'MD', eligible: true },
  { id: 'DDS', name: 'DDS', eligible: true },
  { id: 'LL.M', name: 'LL.M', eligible: true },
  { id: 'Associates', name: "Associate's", eligible: false },
  { id: 'Bootcamp', name: 'Bootcamp', eligible: false },
  { id: 'Postgrad Certificate/Diploma', name: 'Postgrad Certificate/Diploma', eligible: false },
]

export const DEGREES_ELIGIBILITY = {
  USA: [
    { value: 'Masters', label: "Master's" },
    { value: 'MBA', label: 'MBA' },
    { value: 'PhD', label: 'PhD' },
    { value: 'JD', label: 'JD' },
    { value: "Bachelor's", label: "Bachelor's" },
    { value: 'MD', label: 'MD' },
    { value: 'DDS', label: 'DDS' },
    { value: 'LL.M', label: 'LL.M' },
    { value: 'Associates', label: 'Associates' },
    { value: 'Bootcamp', label: 'Bootcamp' },
  ],
  CANADA: [
    { value: 'Masters', label: "Master's" },
    { value: 'MBA', label: 'MBA' },
    { value: 'PhD', label: 'PhD' },
    { value: 'JD', label: 'JD' },
    { value: "Bachelor's", label: "Bachelor's" },
    { value: 'MD', label: 'MD' },
    { value: 'DDS', label: 'DDS' },
    { value: 'LL.M', label: 'LL.M' },
    { value: 'Associates', label: 'Associates' },
    { value: 'Bootcamp', label: 'Bootcamp' },
    { value: 'Postgrad Certificate/Diploma', label: 'Postgrad Certificate/Diploma' },
  ],
}
export const US_SPECIFIC_FIELDS_DEGREES = ['Masters', 'MBA', 'DDS', 'MD'] as const
export const FIELD_OF_STUDY = [
  'Accounting',
  'Nursing',
  'Maths',
  'Computer Science',
  'Business Analytics',
  'Engineering',
  'Economics',
  'Finance',
  'Science',
  'Journalism',
  'Law',
  'Others',
]

export const ENROLLMENT_OPTION = [
  {
    id: 'f',
    name: 'Full-time',

    icon: () => <Icon name="fulltime" />,
  },
  {
    id: 'h',
    name: 'Part-time',
    icon: () => <Icon name="halftime" />,
  },
]

export const NO_BUSINESS_COUNTRIES = [
  { id: 'cuba', country: 'Cuba' },
  { id: 'iran', country: 'Iran' },
  { id: 'southSudan', country: 'South Sudan' },
  { id: 'syria', country: 'Syria' },
  { id: 'northKorea', country: 'North Korea' },
]

export const UI_AND_SF_SYNC_FOR_COUNTRIES = [
  // ✅ NEW UI → MPOWER mappings (differences only) — keep at TOP so find()/filter picks these first
  { ui: 'Aland Islands', sf: 'Åland' },
  { ui: 'Antigua And Barbuda', sf: 'Antigua and Barbuda' },
  { ui: 'Cape Verde', sf: 'Cabo Verde' },
  { ui: 'Cocos (Keeling) Islands', sf: 'Cocos [Keeling] Islands' },
  { ui: 'Congo', sf: 'Republic of the Congo' },
  { ui: "Cote D'Ivoire (Ivory Coast)", sf: "Côte d'Ivoire" },
  { ui: 'Czech Republic', sf: 'Czechia' },
  { ui: 'East Timor', sf: 'Timor-Leste' },
  { ui: 'Falkland Islands', sf: 'Falkland Islands (Islas Malvinas)' },
  { ui: 'Fiji Islands', sf: 'Fiji' },
  { ui: 'French Southern Territories', sf: 'French Southern and Antarctic Lands' },
  { ui: 'Guernsey and Alderney', sf: 'Guernsey' },
  { ui: 'Hong Kong S.A.R.', sf: 'Hong Kong' },
  { ui: 'Macau S.A.R.', sf: 'Macau' },
  { ui: 'Macedonia', sf: 'North Macedonia' },
  { ui: 'Man (Isle of)', sf: 'Isle of Man' },
  { ui: 'Micronesia', sf: 'Federated States of Micronesia' },
  { ui: 'Myanmar', sf: 'Burma' },
  { ui: 'Bonaire, Sint Eustatius and Saba', sf: 'Bonaire' },
  { ui: 'Palestinian Territory Occupied', sf: 'Palestine' },
  { ui: 'Papua new Guinea', sf: 'Papua New Guinea' },
  { ui: 'Pitcairn Island', sf: 'Pitcairn Islands' },
  { ui: 'Saint Kitts And Nevis', sf: 'Saint Kitts and Nevis' },
  { ui: 'Saint Vincent And The Grenadines', sf: 'Saint Vincent and the Grenadines' },
  { ui: 'Saint-Barthelemy', sf: 'Saint Barthelemy' },
  { ui: 'Saint-Martin (French part)', sf: 'Saint Martin' },
  { ui: 'South Georgia', sf: 'South Georgia and the South Sandwich Islands' },
  { ui: 'Sint Maarten (Dutch part)', sf: 'Sint Maarten' },
  { ui: 'Svalbard And Jan Mayen Islands', sf: 'Svalbard and Jan Mayen' },
  { ui: 'Swaziland', sf: 'Eswatini' },
  { ui: 'Trinidad And Tobago', sf: 'Trinidad and Tobago' },
  { ui: 'Turks And Caicos Islands', sf: 'Turks and Caicos Islands' },
  { ui: 'Vatican City State (Holy See)', sf: 'Vatican City' },
  { ui: 'Virgin Islands (British)', sf: 'British Virgin Islands' },
  { ui: 'Virgin Islands (US)', sf: 'U.S. Virgin Islands' },
  { ui: 'Wallis And Futuna Islands', sf: 'Wallis and Futuna' },

  // ⛔ EXISTING legacy mappings — keep EXACTLY as-is at BOTTOM
  { ui: 'Libya', sf: 'Libyan Arab Jamahiriya' },
  { ui: 'Syria', sf: 'Syrian Arab Republic' },
  { ui: 'Russia', sf: 'Russian Federation' },
  { ui: 'Fiji Islands', sf: 'Fiji' },
  { ui: 'Gambia The', sf: 'Gambia' },
  { ui: 'Hong Kong S.A.R.', sf: 'Hong Kong' },
  { ui: 'South Korea', sf: 'Korea' },
  { ui: 'Palestinian Territory Occupied', sf: 'Palestinian Territory, Occupied' },
  { ui: 'Democratic Republic of the Congo', sf: 'Congo, Democratic Republic' },
  { ui: "Cote D'Ivoire (Ivory Coast)", sf: "Cote D'Ivoire" },
  { ui: 'Saint Vincent And The Grenadines', sf: 'Saint Vincent And Grenadines' },
  { ui: 'The Bahamas', sf: 'Bahamas' },
  { ui: 'Brunei', sf: 'Brunei Darussalam' },
  { ui: 'Falkland Islands', sf: 'Falkland Islands (Malvinas)' },
  { ui: 'Guernsey and Alderney', sf: 'Guernsey' },
  { ui: 'Heard Island and McDonald Islands', sf: 'Heard Island & Mcdonald Islands' },
  { ui: 'Vatican City State (Holy See)', sf: 'Holy See (Vatican City State)' },
  { ui: 'Man (Isle of)', sf: 'Isle Of Man' },
  { ui: 'Laos', sf: 'Lao People ́s Democratic Republic' },
  { ui: 'Macau S.A.R.', sf: 'Macao' },
  { ui: 'Micronesia', sf: 'Micronesia, Federated States Of' },
  { ui: 'Pitcairn Island', sf: 'Pitcairn' },
  { ui: 'South Georgia', sf: 'South Georgia And Sandwich Isl.' },
  { ui: 'Svalbard And Jan Mayen Islands', sf: 'Svalbard And Jan Mayen' },
  { ui: 'East Timor', sf: 'Timor-Leste' },
  { ui: 'United States Minor Outlying Islands', sf: 'United States Outlying Islands' },
  { ui: 'Virgin Islands (British)', sf: 'Virgin Islands, British' },
  { ui: 'Virgin Islands (US)', sf: 'Virgin Islands, U.S.' },
  { ui: 'Wallis And Futuna Islands', sf: 'Wallis And Futuna' },
  { ui: 'Sint Maarten (Dutch part)', sf: 'Saint Martin - Dutch' },
  { ui: 'Saint-Martin (French part)', sf: 'Saint Martin - French' },
  { ui: 'Sudan', sf: 'Republic of Sudan (North)' },
  { ui: 'Saint-Barthelemy', sf: 'Saint Barthelemy' },
]

export const OFAC_COUNTRIES = [
  { id: 'balkans', country: 'Balkans' },
  { id: 'belarus', country: 'Belarus' },
  { id: "coteD'Ivorie", country: "Cote D'Ivoire (Ivory Coast)" },
  { id: 'theDemocraticRepublicOfTheCongo', country: 'The Democratic Republic of the Congo' },
  { id: 'iraq', country: 'Iraq' },
  { id: 'liberia', country: 'Liberia' },
  { id: 'lebanon', country: 'Lebanon' },
  { id: 'libya', country: 'Libya' },
  { id: 'northKorea', country: 'North Korea' },
  { id: 'somalia', country: 'Somalia' },
  { id: 'ukraine', country: 'Ukraine' },
  { id: 'yemen', country: 'Yemen' },
  { id: 'zimbabwe', country: 'Zimbabwe' },
]
export const JOB_OFFER_TYPES = [
  {
    id: 'Yes',
    name: 'Yes, I have a post-graduation job offer',
    icon: () => <Icon name="nounPassport" />,
  },
  {
    id: 'Yes_internship',
    name: 'Yes, I have an internship offer',
    icon: () => <Icon name="nounCV" />,
  },
  {
    id: 'No',
    name: "No, I don't have a future job offer",
    icon: () => <Icon name="grupo" />,
  },
]

export const EMPLOYMENT_STATUS_DESKTOP = [
  {
    id: 'Currently employed',
    name: 'Currently employed',
    icon: () => <Icon name="nounPassport" />,
  },
  {
    id: 'Not currently employed, but I have been employed in the past',
    name: "Not currently employed, but I've been employed in the past",
    icon: () => <Icon name="notEmployed" />,
  },
  {
    id: 'I have no employment history',
    name: 'I have no employment history',
    icon: () => <Icon name="history" />,
  },
]

export const EMPLOYMENT_STATUS_MOBILE = [
  {
    id: 'Currently employed',
    name: 'Currently employed',
    icon: () => <Icon name="nounPassport" />,
  },
  {
    id: 'Not currently employed, but I have been employed in the past',
    name: 'Previously employed',
    icon: () => <Icon name="notEmployed" />,
  },
  {
    id: 'I have no employment history',
    name: 'No employment history',
    icon: () => <Icon name="history" />,
  },
]

export const STANDARDIZED_TESTS_SCORE_RANGE = {
  gre: {
    name: 'GRE',
    examType: 'gre',
    placeholder: 'Verbal Reasoning score (130 - 170)',
    min: 130.0,
    max: 170.0,
  },
  greQuantitative: {
    name: 'Quantitative Reasoning',
    examType: 'gre',
    placeholder: 'Quantitative Reasoning score (130 -170)',
    min: 130,
    max: 170,
  },
  gmat: {
    name: 'GMAT',
    examType: 'gmat',
    placeholder: 'Total score (200 - 800)',
    min: 200,
    max: 800,
  },
  gmatPercentile: {
    name: 'Percentile rank',
    examType: 'gmat',
    placeholder: 'Percentile rank (1 -100)',
    min: 1,
    max: 100,
  },
  lsat: {
    name: 'LSAT',
    examType: 'lsat',
    placeholder: 'Total score (120 - 180)',
    min: 120,
    max: 180,
  },
  mcat: {
    name: 'MCAT',
    examType: 'mcat',
    placeholder: 'Total score (472 - 528)',
    min: 472,
    max: 528,
  },
  sat: {
    name: 'SAT',
    examType: 'sat',
    placeholder: 'Total score (400 - 1600)',
    min: 400,
    max: 1600,
  },
  toefl: {
    name: 'TOEFL',
    examType: 'toefl',
    placeholder: 'Total score (0 - 120)',
    min: 0,
    max: 120,
  },
  ielts: {
    name: 'IELTS',
    examType: 'ielts',
    placeholder: 'Total score (0 - 9)',
    min: 0,
    max: 9,
  },
  duolingo: {
    name: 'Duolingo',
    examType: 'duolingo',
    placeholder: 'Total score (0 - 160)',
    min: 0,
    max: 160,
  },
}

export const LANGUAGE_TESTS_SCORE_RANGE = {
  toefl: {
    name: 'TOEFL',
    examType: 'toefl',
    placeholder: 'Total score (0 - 120)',
    min: 0,
    max: 120,
  },
  ielts: {
    name: 'IELTS',
    examType: 'ielts',
    placeholder: 'Total score (0 - 9)',
    min: 0,
    max: 9,
  },
  duolingo: {
    name: 'Duolingo',
    examType: 'duolingo',
    placeholder: 'Total score (0 - 160)',
    min: 0,
    max: 160,
  },
}

export const ADDITIONAL_FUNDING_OPTION_DATA = [
  {
    fundSourceAsk: 'Do you have any scholarships and/or grants for the full programme?',
    fundType: 'Scholarships and grants',
    path: '/id-verification/additional-scholarshipandgrants',
    step: 2,
    show: true,
  },
  {
    fundSourceAsk: 'Do you have any sponsor funding?',
    fundType: 'Sponsor',
    path: '/id-verification/additional-sponsor',
    step: 3,
    show: false,
  },
  {
    fundSourceAsk: 'Do you have personal savings and/or earnings?',
    fundType: 'Personal Savings',
    path: '/id-verification/additional-personalsavings',
    step: 4,
    show: false,
  },
  {
    fundSourceAsk: 'Are any friends or family members providing funds?',
    fundType: 'Relative',
    path: '/id-verification/additional-friendsandfamily',
    step: 5,
    show: false,
  },
]

export const ADDITIONAL_FUNDING_SOURCES = [
  {
    fundSourceAsk: 'Do you have any scholarships and/or grants for the full programme?',
    fundTitle: 'Scholarships and grants',
    fundType: 'Scholarships and grants',
    path: '/id-verification/additional-scholarshipandgrants',
    step: 2,
    show: false,
  },
  {
    fundSourceAsk: 'Do you have any sponsor funding?',
    fundTitle: 'Sponsor',
    fundType: 'Sponsor',
    path: '/id-verification/additional-sponsor',
    step: 3,
    show: false,
  },
  {
    fundSourceAsk: 'Do you have personal savings and/or earnings?',
    fundTitle: 'Personal savings and earnings',
    fundType: 'Personal Savings',
    path: '/id-verification/additional-personalsavings',
    step: 4,
    show: false,
  },
  {
    fundSourceAsk: 'Are any friends or family members providing funds?',
    fundTitle: 'Friends and family support',
    fundType: 'Relative',
    path: '/id-verification/additional-friendsandfamily',
    step: 5,
    show: false,
  },
]

export const COMMON_PDF_LINK = 'https://static.mpowerfinancing.com/public'

export const PRIVACY_POLICY_PDF_LINK = {
  link: 'https://static.mpowerfinancing.com/public/privacy-policy-v2.pdf',
  telephoneConsent:
    'https://static.mpowerfinancing.com/public/Telephone_Consumer_Protection_Act_disclosure.pdf',
  electronicSignatureConsentUSA:
    'https://static.mpowerfinancing.com/public/Consent_to_Use_Electronic_Signatures_and_Receive_Electronic_Disclosures.pdf',
  electronicSignatureConsentCanada:
    'https://static.mpowerfinancing.com/public/consent-use-of-electronic-signature-and-receive-electronic-disclosures-canada.pdf',
  electronicSignatureConsentUSADRBANK:
    'https://static.mpowerfinancing.com/public/Consent_to_Use_Electronic_Signatures_and_Receive_Electronic_Disclosures_dr_bank.pdf',
  blm: 'https://static.mpowerfinancing.com/public/BLM_Privacy_Notice_2019.pdf',
  drBank: 'https://static.mpowerfinancing.com/public/DR-Bank-Privacy-Notice.pdf',
  creditReportAuthorization:
    'https://static.mpowerfinancing.com/public/Disclosure_and_Consent_to_obtain_credit_report.pdf',
  creditReportAuthorizationCanada:
    'https://static.mpowerfinancing.com/public/credit-report-authorization-canada.pdf',
  mlaLink: 'https://static.mpowerfinancing.com/public/MLA.pdf',
  referralPolicy: 'https://static.mpowerfinancing.com/public/referral_terms_and_conditions.pdf',
  referralPolicyDRBank:
    'https://static.mpowerfinancing.com/public/referral_terms_and_conditions_dr_bank.pdf',
}

export const LENDER_NAME = {
  DR_BANK: 'DR_BANK',
  BLM: 'BLM',
  MPOWER: 'MPOWER',
}
export const EXTERNAL_LENDER_NAMES = ['DR_BANK', 'BLM']
export const LENDING_ACT_LINK = {
  US: {
    7.99: 'Truth_In_Lending_Act_Application_Disclosures_7.99.pdf',
    9.99: 'Truth_In_Lending_Act_Application_Disclosures_9.99.pdf',
    11.99: 'Truth_In_Lending_Act_Application_Disclosures_11.99.pdf',
    12.99: 'Truth_In_Lending_Act_Application_Disclosures_12.99.pdf',
    13.99: 'Truth_In_Lending_Act_Application_Disclosures_13.99.pdf',
  },
  Canada: {
    7.99: 'Truth_In_Lending_Act_Application_Disclosures_7.99_Can.pdf',
    9.99: 'Truth_In_Lending_Act_Application_Disclosures_9.99_Can.pdf',
    11.99: 'Truth_In_Lending_Act_Application_Disclosures_11.99_Can.pdf',
    12.99: 'Truth_In_Lending_Act_Application_Disclosures_12.99_Can.pdf',
    13.99: 'Truth_In_Lending_Act_Application_Disclosures_13.99_Can.pdf',
  },
}

export const PROMOCODE = [
  'airfare2022',
  'mpowercn',
  'mpowergea',
  'mpowerhti',
  'mpowerca',
  'mpowerjjl',
  'mpowereic',
  'mpowerxdf',
  'colfuturo200',
  'lae200',
  'grasshopper200',
  'blue200',
  'simalco200',
  'applyboard200',
  'esb200',
  'nomad200',
  'yocket200',
  'gyandhan200',
  'gradright200',
  'unicreds200',
  'mileseducation200',
  'applyboard200',
  'kcoverseas200',
  'leverageedu200',
  'collegepond200',
  'manya200',
  'upgrad200',
  'gradsgateway200',
  'foreignadmits200',
  'physicswallah200',
  'fundabroad200',
  'futurense200',
  'shikshaudaan200',
  'wieducation200',
  'edvoy200',
  'niec-nepal200',
  'vsource-fintech200',
  'edmium200',
  'eec200',
  'globedwise200',
  'interface-education-nepal200',
  'grace-international200',
  'nbyula200',
  'exxeella200',
  'globallyrecruit200',
  'collegedunia200',
  'edufund200',
  'appstec200',
  'aronainternational200',
  'shorelight200',
  'educatly200',
  'dreambuilder200',
  '195globalcompany200',
  'ilavietnam200',
  'centrepointjsc200',
  'bridge200',
  'extudia200',
  'accede200',
  'embajadores200',
  'applyboardlatam200',
  'aecc-india200',
  'aecc-indonesia200',
  'aecc-philippines200',
  'aecc-vietnam200',
  'aecc-bangladesh200',
  'aecc-srilanka200',
  'aecc-nepal200',
  'aecc-nigeria200',
  'aecc-australia200',
  'aecc-thailand200',
  'aecc-malaysia200',
  'aecc-singapore200',
  'northeastern-university200',
  '8b200',
  'impactfinancing200',
  'afterschoolafrica200',
  'edwardconsulting200',
  'aep200',
  'rupegeduconsult200',
  'proueducation200',
  'vesti200',
  'edwisefoundation200',
  'pay4me200',
  'edubanc200',
  'unionbank200',
  'edfin200',
  'ecobank200',
  'enterscale200',
  'proconnectpay200',
  'americanspaces200',
  'careerleapafrica200',
  'titanrconsulting200',
  'mpowernm',
  'colombia200',
  'peru200',
  'gbd200',
  'bd100',
]

export const LOAN_PARTNERS: any = {
  showSallieMae: {
    name: 'Sallie Mae',
    icon: () => <Icon name="sallimae" />,
    url: 'https://www.salliemae.com/landing/student-loans/?MPID=3000000209&dtd_cell=SMLRSOPANLNLOTOTAJZ1083N010000',
    content:
      'For international and U.S.-based students Seeking undergraduate or graduate degrees With U.S.-based cosigner.',
    readMoreContent:
      '<ul class="yellowBullets"><li>Personal loans for international students, graduates, visa holders, and DACA holders.</li><li> No cosigner or collateral.</li></ul>',
  },
  showStilt: {
    name: 'Stilt',
    icon: () => <Icon name="stilt" />,
    url: 'https://www.stilt.com/partners/mpower',
    content:
      'For international and U.S.-based students Seeking undergraduate or graduate degrees With U.S.-based cosigner',
    readMoreContent:
      "<ul class='yellowBullets' ><li>Checking your rate doesn't impact the credit score.</li><li>Buy a car, pay a rental deposit, send money home, etc.</li><li>Students need to be physically in the U.S. to apply.</li></ul>",
  },
  showAscent: {
    name: 'Ascent',
    icon: AscentLogo,
    url: 'https://ascentstudentloans.com/MPower',
    content:
      'For international and U.S.-based students, including DACA Seeking undergraduate or graduate degrees U.S.-based cosigner options.',
    readMoreContent:
      '<ul class="yellowBullets"><li><b>Cosigned loan option</b> <br> Students that are U.S. citizens, have Deferred Action for Childhood Arrival (DACA) status or are not a U.S. citizen or U.S. permanent resident may apply with a creditworthy cosigner that is a U.S. citizen or U.S. permanent resident.</li><li><b>Flexible payment options</b><br>You can choose from affordable fixed or variable rates, customise your repayment terms with the option to start payments up to 9 months after leaving school, and pay off your loan early without any penalty.</li><li><b>Benefits that put you first</b><br>We cover up to 100% of your costs of attendance. Plus, you can get 1% cash back at graduation, and a discount if you set up automatic payments.</li></ul>',
  },
  showAuxilo: {
    name: 'Auxilo',
    icon: AuxiloLogo,
    url: 'https://overseasloan.auxilo.com/register?partnerId=Rk1ub2JGVFhIdTFma0pxWDUvc1RiZz09&partnerName=',
    content:
      'Auxilo Finserve is an RBI-registered, education-focused NBFC enabling students to access future-ready education financing for higher education in India and internationally.',
    readMoreContent:
      '<ul class="yellowBullets"><li><b>Secured and unsecured loan options:</b> <br>Education loans designed to support a wide range of programs, universities, and student profiles.</li><li><b>Flexible repayment options: </b><br>Longer repayment timelines that help reduce financial pressure during and after studies. </li><li><b>Student-first digital lending:</b><br>Transparent, compliant lending practices aligned with Reserve Bank of India (RBI) guidelines, focused on clarity and borrower protection.</li></ul>',
  },
}

export enum tellUsAboutYouEnum {
  thinking = 'I am thinking about studying',
  applied = 'I have applied to study or have been conditionally accepted by my school',
  accepted = 'I have been accepted to study',
  enrolled = 'I am currently enrolled',
  transferring = 'I am currently enrolled at a school, but I am transferring to another school',
}

export const tellUsAboutYou = {
  [tellUsAboutYouEnum.thinking]: {
    backendValue: 'I am thinking about studying',
    yellowTitle: "It's great you're already thinking about funding!",
    blueTitle: 'What U.S. or Canadian school are you interested in attending?',
    textTitle: 'Pick the school you hope to attend.',
    childQuestionTitle: 'Pick the campus you hope to attend.',
    schoolTitleMobile: 'What U.S. or Canadian ',
    schoolTitleMobileBold: 'school are you interested in attending?',
    icon: () => <Icon name="thinking" />,
    name: '<b>Not Applied </b> yet',
    uiValue: 'thinking',
  },
  [tellUsAboutYouEnum.applied]: {
    backendValue: 'I have applied to study or have been conditionally accepted by my school',
    yellowTitle: "It's great you're already thinking about funding!",
    blueTitle: 'What U.S. or Canadian school did you apply to?',
    textTitle:
      'If you applied to multiple schools, pick your top school for now. You can edit this later.',
    icon: () => <Icon name="nonWait" />,
    childQuestionTitle: 'Pick the campus you hope to attend.',
    schoolTitleMobile: 'What U.S. or Canadian ',
    schoolTitleMobileBold: 'school did you apply to?',
    name: '<b>Applied</b>, awaiting admission',
    uiValue: 'applied',
  },
  [tellUsAboutYouEnum.accepted]: {
    backendValue: 'I have been accepted to study',
    yellowTitle: 'Congrats!',
    blueTitle: 'What U.S. or Canadian school were you accepted to?',
    textTitle: 'Pick the school you will attend.',
    childQuestionTitle: 'Pick the campus you will attend.',
    schoolTitleMobile: 'What U.S. or Canadian ',
    schoolTitleMobileBold: 'school were you accepted to?',
    icon: () => <Icon name="check" />,
    name: '<b>Accepted</b>, yet to start classes',
    uiValue: 'accepted',
  },
  [tellUsAboutYouEnum.enrolled]: {
    backendValue: 'I am currently enrolled',
    yellowTitle: 'Great!',
    blueTitle: 'What U.S. or Canadian school do you attend?',
    textTitle: 'Pick the school you attend.',
    childQuestionTitle: 'Pick the campus you attend.',
    schoolTitleMobile: 'What U.S. or Canadian ',
    schoolTitleMobileBold: 'school do you attend?',
    icon: () => <Icon name="papel" />,
    name: '<b>Enrolled</b>, attending classes',
    uiValue: 'enrolled',
  },
  [tellUsAboutYouEnum.transferring]: {
    backendValue: 'I am currently enrolled at a school, but I am transferring to another school',
    yellowTitle: 'Sounds good.',
    blueTitle: 'What U.S. or Canadian school will you transfer to?',
    textTitle: 'Pick the school you will attend.',
    childQuestionTitle: 'Pick the campus you will attend.',
    schoolTitleMobile: 'What U.S. or Canadian ',
    schoolTitleMobileBold: 'school will you transfer to?',
    icon: () => <Icon name="write" />,
    name: '<b>Transferring</b> to a new school',
    uiValue: 'transferring',
  },
}

export const STANDARDIZED_TESTS = [
  { id: 'gre', label: 'GRE' },
  { id: 'gmat', label: 'GMAT' },
  { id: 'lsat', label: 'LSAT' },
  { id: 'mcat', label: 'MCAT' },
  { id: 'sat', label: 'SAT' },
  { id: 'waived', label: 'Waived' },
  { id: 'haventTaken', label: "Haven't Taken" },
]

export const LANGUAGE_TESTS = [
  { id: 'toefl', label: 'TOEFL' },
  { id: 'ielts', label: 'IELTS' },
  { id: 'duolingo', label: 'Duolingo' },
  { id: 'waived', label: 'Waived' },
  { id: 'haventTaken', label: "Haven't Taken" },
]
export const TIP_CONTENT = {
  generic: `If you select "Fall/Spring," your loan will be applied to the full year of
  your education. Processing loans on an annual basis is easier for you, for us, and
  for your school!`,
  fall2024: `Select the Fall 2024 academic period if your loan was approved for "Spring 2024 & Fall 2024" Academic Period`,
  springFall2024: `Some schools only accept funds for one semester at a time. If this happens to your application, we’ll notify you to confirm your next funding request.`,
  rbAY: 'We recommend selecting the full academic year, as schools are more likely to approve the full loan amount while assessing your financial need.',
  semTip: 'This helps us tailor your loan amount and schedule.',
  usTip:
    'If you select "fall/spring", your loan will be applied to the full year of your education. Processing loans on an annual basis is easier for you, for us and for your school!',
}

export const AY_SHORT_ABBREVIATION = [
  {
    uiName: 'Spring 2026',
    sfName: 'Spring 2026',
  },
  {
    uiName: 'Summer 2026',
    sfName: 'Summer 2026',
  },
  {
    uiName: 'Fall 2026',
    sfName: 'Fall 2026',
  },
  {
    uiName: 'Fall 26 / Sprg 27',
    sfName: 'Fall 2026 & Spring 2027',
  },
]

export const LINKS_TO_MODULES = [
  { id: 'personal', title: 'Personal', path: '/personal' },
  { id: 'education', title: 'Education', path: '/education' },
  { id: 'employment', title: 'Employment', path: '/employment' },
  { id: 'finance', title: 'Finance', path: '/finance' },
]

const BASE_ID_TYPES = {
  identity: {
    id: 'Identity document',
    name: 'Identity document',
    icon: () => <Icon name="identity" />,
  },
  drivers: {
    id: "Driver's license",
    name: "Driver's license",
    icon: () => <Icon name="nounPassport" />,
  },
  state: {
    id: 'State or government ID',
    name: 'State or government ID',
    icon: () => <Icon name="nounPassport" />,
  },
  passport: { id: 'Passport', name: 'Passport', icon: () => <Icon name="passport" /> },
}

export const ID_CONFIG = {
  US: {
    verifyIdentity: [BASE_ID_TYPES.drivers],
    alternateId: [BASE_ID_TYPES.identity, BASE_ID_TYPES.state, BASE_ID_TYPES.passport],
  },
  NON_US: {
    verifyIdentity: [BASE_ID_TYPES.passport],
    alternateId: [BASE_ID_TYPES.identity, BASE_ID_TYPES.drivers, BASE_ID_TYPES.state],
  },
}

export enum DOCUMENT_UPLOAD_TYPES {
  PASSPORT = 'Passport',
  IDENTITY_DOC = 'Identity document',
  DRIVER_LICENSE = "Driver's license",
  STATE_GOVT_ID = 'State or government ID',
}

export const ALL_VERIFIED = [
  { id: 'legalName', name: 'Legal name', icon: () => <Icon name="blueTick" /> },
  { id: 'passportCountry', name: 'Document country', icon: () => <Icon name="blueTick" /> },
  { id: 'dob', name: 'Date of birth', icon: () => <Icon name="blueTick" /> },
]

export const PROGRAM_START_DATE_QUES = ["What's your expected", 'What was your']

export const DEGREE_TIP_TEXT = [
  'This is the day your upcoming academic period starts and when you will need your money.',
  'This is the day the program you are currently enrolled in started.',
]

export const PROGRAM_START_DATE_SUB_TEXT = [
  'This should be the approximate date your future classes start.',
  'This should be the date your classes started',
]

export const DEDUPE_SCENARIOS = [
  {
    scenario: 1,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: null,
    navigation: '/eligibility/degree',
    school: true,
    rightButtonStyle: 'invisibleButton',
    newApp: undefined,
  },
  {
    scenario: 1,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: null,
    navigation: '/eligibility/degree',
    school: true,
    rightButtonStyle: 'invisibleButton',
    newApp: 'true',
  },
  {
    scenario: 2,
    leftButtonText: 'LOGIN',
    rightButtonText: 'START NEW APPLICATION',
    scenarioText:
      'It looks like you already have an application in process. Please log in to continue your application where you left off. Login credentials were emailed to you when you started the application.',
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'plainTextButton',
    newApp: undefined,
  },
  {
    scenario: 2,
    leftButtonText: 'GO TO DASHBOARD',
    rightButtonText: 'START NEW APPLICATION',
    scenarioText:
      'It looks like you already have an application in process. You can continue your application where you left off, from your dashboard.',
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'plainTextButton',
    newApp: 'true',
  },
  {
    scenario: 3,
    leftButtonText: 'CHECK APPLICATION STATUS',
    rightButtonText: '',
    scenarioText:
      'We’re currently reviewing the application you submitted for this school. Please log in to check your application status. Login credentials were emailed to you for your submitted application.',
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'invisibleButton',
    newApp: undefined,
  },
  {
    scenario: 3,
    leftButtonText: 'CHECK APPLICATION STATUS',
    rightButtonText: 'START NEW APPLICATION',
    scenarioText:
      'We’re reviewing your submitted loan application for this school and will update you soon. Do you still want to create another application?',
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'plainTextButton',
    newApp: 'true',
  },
  {
    scenario: 4,
    leftButtonText: null,
    rightButtonText: 'Check My Application Status',
    scenarioText:
      "Since you are applying to the same school, we're moving you to a faster experience.",
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'invisibleButton',
    newApp: undefined,
  },
  {
    scenario: 4,
    leftButtonText: null,
    rightButtonText: '',
    scenarioText:
      "Since you are applying to the same school, we're moving you to a faster experience.",
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'invisibleButton',
    newApp: 'true',
  },
  {
    scenario: null,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: null,
    navigation: '/eligibility/degree',
    rightButtonStyle: 'invisibleButton',
    school: true,
    newApp: undefined,
  },
  {
    scenario: null,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: null,
    navigation: '/eligibility/degree',
    rightButtonStyle: 'invisibleButton',
    school: true,
    newApp: 'true',
  },
  {
    scenario: 5,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: false,
    navigation: '/eligibility/degree',
    school: true,
    rightButtonStyle: 'invisibleButton',
    newApp: undefined,
  },
  {
    scenario: 5,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: false,
    navigation: '/eligibility/degree',
    school: true,
    rightButtonStyle: 'invisibleButton',
    newApp: 'true',
  },
  {
    scenario: 5,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: true,
    navigation: '/eligibility/degree',
    school: true,
    rightButtonStyle: 'invisibleButton',
    newApp: undefined,
  },
  {
    scenario: 5,
    leftButtonText: '',
    rightButtonText: '',
    scenarioText: '',
    aanDays: true,
    navigation: '/eligibility/degree',
    school: true,
    rightButtonStyle: 'invisibleButton',
    newApp: 'true',
  },
  {
    scenario: 6,
    leftButtonText: 'Login',
    rightButtonText: '',
    scenarioText:
      'It looks like you already have an <b>Approved</b> application in process. Please log in to continue your application to complete the final steps.   Login credentials were emailed to you when you started the application.',
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'invisibleButton',
    newApp: undefined,
  },
  {
    scenario: 6,
    leftButtonText: 'Accept Loan Terms',
    rightButtonText: '',
    scenarioText:
      'It looks like you already have an <b>Approved</b> application in process. Please complete the final steps of your existing application before starting a new one.',
    aanDays: null,
    navigation: '',
    school: false,
    rightButtonStyle: 'invisibleButton',
    newApp: 'true',
  },
]
export const DEFER_OPTIONS = [
  { id: 'Admission deferral', name: 'Admission deferral' },
  { id: 'Visa appointment unavailable', name: 'Visa appointment unavailable' },
  { id: 'Visa denied', name: 'Visa denied' },
  { id: 'I received funding elsewhere', name: 'I received funding elsewhere' },
]

export const APPLICATION_STATUS_EXCEPTIONS = {
  verificationStatus: [
    'application under review',
    'initial review completed - awaiting documents',
    'conditional offer - awaiting documents',
  ],
  finalReviewStatus: [
    'documents complete - under review',
    'support letter available - awaiting i20',
  ],
  fundStatus: [
    'review and accept loan offer',
    'review and sign final loan documents',
    'pending school certification',
    'sent for school certification',
    'school certification received',
    'loan esigned - awaiting visa',
  ],
}

export const DOCUMENT_UPLOAD_CHECKBOXES = [
  {
    checkboxId: 'noFundingProof1',
    checkboxCondition: 'Funding - Savings/Investment Document',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noFundingProof2',
    checkboxCondition: 'Funding - Business Registration',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noFundingProof3',
    checkboxCondition: 'Funding - Sponsor ID',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noFundingProof4',
    checkboxCondition: 'Funding - Sponsor Letter',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noFundingProof5',
    checkboxCondition: 'Scholarship/Grant',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noFundingProof6',
    checkboxCondition: 'Funding - Earnings',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noFundingProof7',
    checkboxCondition: 'Funding - Employer sponsorship',
    checkboxLabel: 'Please select if you no longer have this funding proof',
    fundingRelated: true,
    additionalFundingRelated: false,
  },
  {
    checkboxId: 'noAdditionalFund',
    checkboxCondition: 'Additional Funding',
    checkboxLabel: 'Please select if you do not have additional funding',
    fundingRelated: false,
    additionalFundingRelated: true,
  },
]
export const CREATE_LEAD_COMPULSORY_FIELDS = ['lastName', 'firstName', 'emailID', 'tellUsAboutYou']
export const DOB_FIELD_CONFIGS = [
  {
    label: 'Year',
    id: 'dobYearField',
    name: 'dobYearField',
    placeholder: 'Type year',
    nothingFoundMessage: 'Provide valid year',
  },
  {
    label: 'Month',
    id: 'dobMonthField',
    name: 'dobMonthField',
    placeholder: 'Type month',
    nothingFoundMessage: 'Provide valid month',
  },
  {
    label: 'Day',
    id: 'dobDayField',
    name: 'dobDayField',
    placeholder: 'Type day',
    nothingFoundMessage: 'Provide valid day',
  },
]
export const DEFER_INFO_TEXT = {
  deferLinkInfo:
    'You have recently submitted a Deferral request and it is currently under review. Our team will contact you as needed.',
  deferUnderReview:
    'You have recently submitted a Deferral request and it is currently under review. Our team will contact you as needed.',
  deferApproved: 'Your deferral request has been approved. Your current loan start term is set to',
  deferRejected: "Your deferral request can't be processed.",
  deferInfoMessageUnderReview: 'Your deferral request has been submitted for review.',
  deferInfoMessageUnderApproved: 'Your deferral request has been approved.',
  deferInfoMessageUnderRejected: 'Please start a new loan application',
  deferInfoCancelMessage:
    'Your loan application has previously been deferred and it can only be deferred one time.',
  deferInfoCancelMessageOnePlusOne: 'Your loan application has previously been deferred.',
  deferInfoNonCancelMessage:
    'Your loan application has previously been deferred and it can only be deferred one time. Please start a new loan application after you',
  deferExpires:
    'To defer your loan start date to the next academic term click, on "Defer my loan start date".',
  deferCurrentDateSetTo: 'Your current loan start term is set to',
  deferMpowerLimitText:
    "MPOWER allows deferrals up to two academic terms. You've reached the two-term limit.",
  deferMaxLimitText:
    "MPOWER allows deferrals up to two academic terms. You've reached the two-term limit. Please start a new loan application after you",
  deferCancelMessage: 'that you would like to cancel your original loan application',
  deferTipSecondTime:
    "You've already deferred once and can defer to the next term (one more time) while keeping your same loan terms without needing to reapply. \n\nDeferring your loan is the best option if you're waiting for your visa, deferring your admission or program start, or if you received additional funding sources and want to use your MPOWER funds later in your program.",
  deferTipFirstTime:
    "You can defer  your loan to a future semester. This is possible for up to two academic terms, either one term at a time or two terms at once, while keeping your existing loan terms. \n\nDeferring your loan is the best option if you're waiting for your visa, deferring your admission or program start, or if you received additional funding sources and want to use your MPOWER funds later in your program.",
  deferMicroSegmentMessage:
    'Based on our updated eligibility criteria, your application cannot be deferred.',
  deferUSTravelBanMessage:
    "MPOWER can't support your application due to U.S. entry restrictions. The U.S. government currently restricts entry and/or visa issuance for nationals of certain countries, which may impact student visa eligibility. You can learn more on the",
  deferUSTravelBanLinkText: "U.S. government's website",
  deferMicroSegmentAdditionalText: 'We encourage you to visit',
  deferMicroSegmentSchoolLinkText: 'Schools We Support page',
  deferMicroSegmentEligibilityText: 'and check your',
  deferMicroSegmentEligibilityLinkText: 'Eligibility',
  deferMicroSegmentEndText: 'with a different school/program.',
  ineligible:
    'No deferrable terms are available for your program right now. Please try a later academic year or contact support.',
  chinaIneligible:
    "We're sorry to inform you that MPOWER is currently unable to support deferral requests for students from your country of citizenship.",
  deferralPausedMessage:
    "We are currently not accepting deferral requests. We'll notify you if there are any deferral updates.",
}
export const DEFER_SF_STATUS = {
  ELIGIBLE: 'Eligible',
  SUBMITTED: 'Submitted',
  DEFERRED: 'Deferred',
  REJECTED: 'Rejected',
  EMPTY: '',
  MICROSEGMENT_DECLINE: 'MicroSegment decline',
  INELIGIBLE: 'Ineligible',
  US_TRAVEL_BAN: 'US Travel Ban',
  HOLD_INELIGIBLE_SCHOOLS: 'Hold Ineligible schools',
  CHINA_INELIGIBLE: 'China ineligible',
}
export const DEFER_REASONS = {
  FUNDING_ELSEWHERE: 'I received funding elsewhere',
  ADMISSION_DEFERRAL: 'Admission deferral',
  VISA_APPOINTMENT_UNAVAILABLE: 'Visa appointment unavailable',
  VISA_DENIED: 'Visa denied',
}
export const APP_STATUS_LIST_FOR_FINAL_VALUE = [
  'review and sign final loan documents',
  'rescission period',
  'loan esigned - awaiting visa',
  'funding in progress',
  'loan disbursed',
]
export const APP_STATUS_LIST_ATIL_VALUE = [
  'review and accept loan offer',
  'pending school certification',
  'sent for school certification',
  'school certification received',
]

export const PAGE_NAME = {
  personal: 'personal_information',
  education: 'educational_information',
  employment: 'employment_information',
  finance: 'financial_information',
}

export const MINIMUM_YEAR_LIMIT = 1924
export type TTellUsAboutYou = keyof typeof tellUsAboutYou

export const ELIGIBILITY_COMPULSORY_FIELDS = [
  { key: 'firstName', routeName: '/eligibility/' },
  { key: 'lastName', routeName: '/eligibility/' },
  { key: 'emailID', routeName: '/eligibility/' },
  { key: 'tellUsAboutYou', routeName: '/eligibility/persona' },
  { key: 'schoolName', routeName: '/eligibility/school' },
  { key: 'universityName', routeName: '/eligibility/school' },
  { key: 'citizenshipCountry', routeName: '/eligibility/citizenship' },
  { key: 'howDidYouHearAboutUs', routeName: '/eligibility/citizenship' },
  { key: 'degree', routeName: '/eligibility/degree' },
  { key: 'programStartDate', routeName: '/eligibility/degree' },
  { key: 'expectedGradDate', routeName: '/eligibility/degree' },
  { key: 'gpa', routeName: '/eligibility/degree' },
  { key: 'privacyPolicy', routeName: '/eligibility/confirm' },
]

export const ERRORS = {
  selectOne: 'Please select one',
}

export const FRANKLIN_SCHOOL = 'Franklin University'

export const CANCEL_REASONS = {
  decidedNotToAttend: {
    label: 'Decided not to attend school at all.',
    value: 'Decided not to attend school at all.',
  },
  approvalNotCoverTuition: {
    label: 'Approval amount not enough to cover tuition.',
    value: 'Approval amount not enough to cover tuition.',
  },
  obtainedScholarship: {
    label: 'Obtained additional scholarship or funding.',
    value: 'Obtained additional scholarship or funding.',
  },
  otherLoanAccepted: {
    label: 'Accepted loan offer from other provider.',
    value: 'Accepted loan offer from other provider.',
  },
  highInterest: {
    label: 'Interest rate too high.',
    value: 'Interest rate too high.',
  },
  highOriginationFee: {
    label: 'Origination fees too high.',
    value: 'Origination fees too high.',
  },
  highMonthlyPayment: {
    label: 'Monthly payment amount too high.',
    value: 'Monthly payment amount too high.',
  },
  visaDenied: {
    label: 'Visa denied.',
    value: 'Visa denied.',
  },
  transferring: {
    label: 'Transferring to a different university.',
    value: 'Transferring to a different university.',
  },
  admissionDeferred: {
    label: 'Admission deferred.',
    value: 'Admission deferred.',
  },
  duplicateApplication: {
    label: 'Duplicate application.',
    value: 'Duplicate application.',
  },
  other: {
    label: 'Other',
    value: 'Other',
  },
}

export const CONTACT_US_LINK = 'https://www.mpowerfinancing.com/contact-us'
export const MILES_UNIVERSITY_ID = 'a00UU00000O4EufYAF'
export const FINAL_SUBMIT_OBJECT_KEY = 'final_submit'
export const ACADEMIC_PERIOD_WARNING_MESSAGE =
  'You already have an application for this school and term. Are you sure you want to submit another application for this term?'
export const CHINA = 'China'
export const WECHAT = 'WeChat'

export const NAVIGATION_ITEMS = [
  {
    label: 'Account Summary',
    src: '/images/navigation/navIcon1.png',
    hoverSrc: '/images/navigation/navIcon1hover.png',
    href: '/dashboard',
  },
  {
    label: 'Inactive Applications',
    src: '/images/navigation/navIcon2.png',
    hoverSrc: '/images/navigation/navIcon2hover.png',
    href: '/inactive-applications',
  },
  {
    label: 'Bank Accounts',
    src: '/images/navigation/navBankAccount.svg',
    hoverSrc: '/images/navigation/navBankAccountHover.svg',
    href: '/dashboard/bank-account',
  },
  {
    label: 'Support Center',
    src: '/images/navigation/navIcon3.png',
    hoverSrc: '/images/navigation/navIcon3hover.png',
    href: 'https://support.mpowerfinancing.com/hc/en-us',
    target: '_blank',
  },
  {
    label: 'Refer a friend',
    src: '/images/navigation/navIcon4.png',
    hoverSrc: '/images/navigation/navIcon4hover.png',
    href: 'https://www.mpowerfinancing.com/get-a-loan/refer',
    target: '_blank',
  },
  {
    label: 'FAQ',
    src: '/images/navigation/navIcon5.png',
    hoverSrc: '/images/navigation/navIcon5hover.png',
    href: 'https://www.mpowerfinancing.com/blog/mpowers-top-faqs',
    target: '_blank',
  },
  {
    label: 'T & C',
    src: '/images/navigation/navIcon6.png',
    hoverSrc: '/images/navigation/navIcon6hover.png',
    href: 'https://www.mpowerfinancing.com/terms-of-service',
    target: '_blank',
  },
  {
    label: 'Free Career Bootcamp',
    src: '/images/navigation/navIcon7.png',
    hoverSrc: '/images/navigation/navIcon7hover.png',
    href: '/dashboard#careerBootCamp',
  },
  {
    label: 'Handpicked Services',
    src: '/images/navigation/navIcon8.png',
    hoverSrc: '/images/navigation/navIcon8hover.png',
    href: '/dashboard#marketplace',
  },
]

export const TAS_USERS_URL = {
  IS_SCHOOL_LIST_LINK:
    'https://www.internationalstudent.com/student-news/articles/choosing-a-school/',
  MPOWER_SCHOOL_LIST_LINK: 'https://www.mpowerfinancing.com/get-a-loan/schools-we-support#schools',
  US_TRAVEL_BAN_LINK:
    'https://www.whitehouse.gov/fact-sheets/2025/12/fact-sheet-president-donald-j-trump-further-restricts-and-limits-the-entry-of-foreign-nationals-to-protect-the-security-of-the-united-states/',
}
export const ID_VERIFICATION_FIELDS = {
  NAME: 'Legal name',
  DOB: 'Date of Birth',
  NATIONALITY: 'Nationality',
} as const

export const ID_VERIFICATION_OPTIONS = {
  ID_VERIFIED: 'id-verified',
  ENTERED_INFO: 'entered-info',
} as const

export const ID_VERIFICATION_BUTTON_VALUES = {
  SEND_ID_DATA: 'sendIdData',
  SEND_ENTERED_DATA: 'sendEnteredData',
} as const

export const INTERSTETIAL_TEXTS = {
  message:
    'Easy loan application, timely customer service, webinars to update clients and also great support throughout the journey... definitely what I needed most. Thanks MPOWER for empowering me to realize my goals.',
  name: 'Elvis',
}
export const NO_EMPLOYMENT_STATUSES = [
  'I have no employment history',
  'Not currently employed, but I have been employed in the past',
]

export const HARDSHIP_PROGRAM_TYPE = [
  {
    id: 'email',
    name: 'Email',
    icon: () => <Icon name="college" />,
  },
  {
    id: 'phone',
    name: 'Phone',
    icon: () => <Icon name="online" />,
  },
  {
    id: 'whatsapp',
    name: 'Whatsapp',
    icon: () => <Icon name="hybrid" />,
  },
]

export const EMPLOYMENT_JOB_STEP_NUMBER = 3
